import React, { Component } from 'react';

import TextField from 'material-ui/TextField';

import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';

const MAX_SUPERSET_INSTRUCTIONS_LENGTH = 2500;

export default class SupersetInstructions extends Component {
    state = {
        instructions: this.props.block.instruction || ''
    };

    characterCount = () => {
        const length = this.state.instructions.length;
        return `${length}/${MAX_SUPERSET_INSTRUCTIONS_LENGTH}`;
    };

    handleChange = event => {
        const instructions = event.target.value;
        if (instructions.length <= MAX_SUPERSET_INSTRUCTIONS_LENGTH) {
            this.setState({ instructions });
        }
    };

    updateInstructions = event => {
        const instructions = event.target.value;
        const block = this.props.block;
        if (instructions === block.instruction) {
            return;
        }
        const dispatch = this.props.dispatch;
        DesignerState.updateBlock(dispatch, block, 'instruction', instructions);
    };

    render() {
        Console.render('designer.SuperSetInstructions');
        return (
            <div className="block-notes">
                <span className="th-textarea-label">Superset Instructions</span>
                <TextField
                    id="multiline"
                    className="th-textarea"
                    multiline
                    value={this.state.instructions}
                    onChange={this.handleChange}
                    onBlur={this.updateInstructions}
                    margin="normal"
                    fullWidth
                    placeholder="Ex. Rest 45s between exercises."
                />
                <span className="character-count">{this.characterCount()}</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/Block/SupersetInstructions.jsx